import { ObservableArray, View } from "binder"
import { district, DistrictHistoriessViewModel } from "./districtHistoriess-viewModel"

export class DistrictHistoriessView extends View<DistrictHistoriessViewModel>{
    GetViewUniqueId(): string {
        return "V-1239EDA2-401B-4504-9135-06FC2DF3FA6B"
    }
    loadHtml(): string {
        let element = require('./districtHistoriess.html').default;
        let style = require('./districtHistoriess.less');
        return element;
    }
    constructor() {
       super();
    }
    public set districts(v: ObservableArray<district>) { this._districts = v; } public get districts(): ObservableArray<district> { return this._districts;} private _districts: ObservableArray<district>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    async closeAll() {
        this.dataContext.closeAllDistrict();
    }
}
